import r2wc from "@r2wc/react-to-web-component";
import { amplitudeEventBridgeForClickEvents, initSentry } from "./tracking";

export const convertReact2WebComponent = (
  Component: Parameters<typeof r2wc>[0],
  options?: Parameters<typeof r2wc>[1],
) => {
  initSentry();

  const WebComponent: CustomElementConstructor = r2wc(Component, options);

  class WebComponentWithStyle extends WebComponent {
    connectedCallback() {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      super.connectedCallback();
      initSentry();
      const styleTag = document.getElementById("jobrad-rechner-styles");
      if (styleTag) {
        this.shadowRoot?.append(styleTag.cloneNode(true));
      }

      // Listen for clicks inside the shadow DOM
      this.shadowRoot?.addEventListener("click", amplitudeEventBridgeForClickEvents, true); // Use capture phase to catch it early
    }
  }

  return WebComponentWithStyle;
};
